import { render, staticRenderFns } from "./ProductCardItem.vue?vue&type=template&id=5307e4ee&"
import script from "./ProductCardItem.vue?vue&type=script&lang=js&"
export * from "./ProductCardItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports